import { ColDef } from 'ag-grid-community'
import { DateCellComponent } from '../cells/date-cell.component'
import { TableHeaderComponent } from '../headers/table-header.component'
import { ServicePointCellComponent } from '../cells/service_point_cell.component'
import { dateOnlyFormat } from '../../../shared/utilities/date'
import { IntervalUsage } from 'src/app/shared/models/intervalUsage'
import { NumberCellComponent } from '../cells/number-cell.component'

const filterGroup = 'import_inteval_usage'

export class ImportIntervalUsageColumnDefinition {
  sharedDef: ColDef = {
    filter: false,
    sortable: false,
    editable: false,
    minWidth: 100,
    width: 150,
  }

  getColDefs = (): ColDef[] => [
    {
      ...this.sharedDef,
      flex: 1,
      width: 165,
      headerName: 'Service Point',
      field: 'service_point_uid',
      cellRenderer: ServicePointCellComponent,
      headerComponent: TableHeaderComponent,
      headerComponentParams: {
        filterGroup,
        additionalFields: ['service_point_group_uid', 'service_point_id_search'],
      },
    },
    {
      ...this.sharedDef,
      filter: true,
      sortable: true,
      headerName: 'Market Interval',
      field: 'market_interval',
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: `${dateOnlyFormat} HH:00`,
        date: (d: IntervalUsage) => d.market_interval,
      },
      headerComponent: TableHeaderComponent,
      headerComponentParams: {
        filterGroup,
      },
    },
    {
      ...this.sharedDef,
      headerName: 'Usage (kW\u00A0h)',
      field: 'measurement_value',
      cellRenderer: NumberCellComponent,
      cellRendererParams: {
        num: (d: IntervalUsage) => d.measurement_value,
        precision: 8,
      },
      headerComponent: TableHeaderComponent,
      headerComponentParams: {
        filterGroup,
      },
    },
  ]
}
